import { message, Select } from '@drip/drip-design';
import React, { useMemo, useState, useEffect } from 'react';
import './index.less';
import apis from '@/pages/product-manager/sale-plan/components/sales-plan-drawer/apis';
import { LOAD_STATUS } from '@/components/loadable';
import batchedupdates from '@/common/utils/batched-updates';
import { debounce } from 'lodash';

export function useQueryList(query) {
  const [loadStatus, setLoadStatus] = useState(LOAD_STATUS.FIRST);
  const [state, setState] = useState();

  useEffect(() => {
    let didMount = true;
    setLoadStatus(LOAD_STATUS.ING);
    apis
      .marketingPlanSelectorData(query)
      .then((res) => {
        if (!didMount) return;
        const { ret, msg, data } = res || {};
        if (ret !== '0' || !data) throw msg || '网络异常请稍候~';
        let list = data.list;
        if (query.type != 2) {
          list = data.list?.map((item) => {
            const { value, label } = item;
            return { value, label: label + value };
          });
        }
        batchedupdates(() => {
          setState(list);
          setLoadStatus(LOAD_STATUS.SUCCESS);
        });
      })
      .catch((ex) => {
        setLoadStatus(LOAD_STATUS.FAILED);
        message.error(ex);
      });
    return () => {
      didMount = false;
    };
  }, [query]);

  const data = useMemo(() => {
    const loading = loadStatus === LOAD_STATUS.ING || loadStatus === LOAD_STATUS.FIRST;
    return { loading, data: state, loadStatus };
  }, [loadStatus, state]);

  return [data];
}

export default function ProductSku({ type, value, onChange }) {
  const [searchVal, setSearchVal] = useState('');
  const query = useMemo(() => {
    return { type: type, name: searchVal };
  }, [searchVal, type]);
  const [{ data: goodsList }] = useQueryList(query);

  const onSelectChange = (val, option) => {
    onChange(option);
  };
  return (
    <Select
      allowClear={false}
      style={{ width: 128 }}
      value={value?.value}
      options={goodsList}
      onSearch={debounce((val) => setSearchVal(val), 800)}
      filterOption={() => true}
      showSearch
      onChange={onSelectChange}
      placeholder="请选择"
    />
  );
}
